export type OperationModelId = 'physical-store' | 'mobile-seller' | 'online-only' | 'warehouse' | 'service-area';

export type OperationModel = {
  id: OperationModelId;
  label: string;
  description: string;
  operationPointLabel: string;
  defaultPointName: string;
  addressOptional: boolean;
  defaultCashControl: boolean;
};

export const operationModels: Record<OperationModelId, OperationModel> = {
  'physical-store': {
    id: 'physical-store', label: 'Local abierto al público', description: 'Vendes desde una tienda, restaurante, barra o sucursal física.',
    operationPointLabel: 'Sucursal', defaultPointName: 'Sucursal principal', addressOptional: false, defaultCashControl: true,
  },
  'mobile-seller': {
    id: 'mobile-seller', label: 'Venta móvil o por catálogo', description: 'Vendes por redes, visitas, entregas, apartados o encargos sin local fijo.',
    operationPointLabel: 'Operación', defaultPointName: 'Venta móvil y entregas', addressOptional: true, defaultCashControl: false,
  },
  'online-only': {
    id: 'online-only', label: 'Solo en línea', description: 'Recibes pedidos digitales y coordinas envíos o puntos de entrega.',
    operationPointLabel: 'Canal operativo', defaultPointName: 'Pedidos en línea', addressOptional: true, defaultCashControl: false,
  },
  warehouse: {
    id: 'warehouse', label: 'Bodega o centro de distribución', description: 'No atiendes mostrador; controlas inventario, pedidos y entregas.',
    operationPointLabel: 'Bodega', defaultPointName: 'Bodega principal', addressOptional: false, defaultCashControl: false,
  },
  'service-area': {
    id: 'service-area', label: 'Servicio a domicilio o por zona', description: 'El equipo se mueve con el cliente y cobra trabajos o anticipos.',
    operationPointLabel: 'Zona operativa', defaultPointName: 'Zona principal', addressOptional: true, defaultCashControl: false,
  },
};

export const getOperationModel = (id?: string) => operationModels[(id as OperationModelId) ?? 'physical-store'] ?? operationModels['physical-store'];
